
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/full-page-map",
      function () {
        return require("private-next-pages/full-page-map.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/full-page-map"])
      });
    }
  